import { Column } from "../../../../components/TableDataGridV2/types";
import { IdataPrescricoes } from "../../../../types/api/geral/pesquisar-prescricoes";

export const colunasPrescricao: Column<IdataPrescricoes>[] = [
    {
        id: 'id',
        label: 'Código',
        type: "text",
        filter: true,
        numeric: false,
        sortable: true,
        minWidth: 80,
    },
    {
        id: 'agrotoxico.marca_comercial',
        label: 'Agrotóxico',
        type: "text",
        filter: true,
        numeric: false,
        sortable: true,
        minWidth: 150,
    },
    {
        id: 'cultura.nome',
        label: 'Cultura',
        type: "text",
        filter: true,
        numeric: false,
        sortable: true,
        minWidth: 150,
    },
    {
        id: 'quantidade_dose',
        label: 'Quantidade de Dose',
        type: "number",
        filter: false,
        numeric: true,
        sortable: false,
        minWidth: 180,
    },
    {
        id: 'unidade_dose',
        label: 'Unidade de Dose',
        type: "text",
        filter: false,
        numeric: false,
        sortable: false,
        minWidth: 150,
    },
    {
        id: 'tamanho_area',
        label: 'Tamanho da Área',
        type: "number",
        filter: false,
        numeric: true,
        sortable: false,
        minWidth: 150,
    },
    {
        id: 'unidade_area',
        label: 'Unidade da Área',
        type: "text",
        filter: false,
        numeric: false,
        sortable: false,
        minWidth: 150,
    },
    {
        id: 'quantidade_aplicacoes',
        label: 'Qtd. Aplicações',
        type: "number",
        filter: true,
        numeric: true,
        sortable: true,
        minWidth: 160,
    },
    {
        id: 'dias_intervalo_aplicacoes',
        label: 'Intervalo Aplicações (dias)',
        type: "number",
        filter: true,
        numeric: true,
        sortable: true,
        minWidth: 220,
    },
    {
        id: 'dias_carencia',
        label: 'Dias de Carência',
        type: "number",
        filter: true,
        numeric: true,
        sortable: true,
        minWidth: 150,
    },
    {
        id: 'complemento',
        label: 'Complemento',
        type: "text",
        filter: true,
        numeric: false,
        sortable: true,
        minWidth: 200,
    },
    {
        id: 'modo_aplicacao',
        label: 'Modo de Aplicação',
        type: "truncated",
        filter: true,
        numeric: false,
        sortable: true,
        minWidth: 200,
    },
    {
        id: 'epoca_aplicacao',
        label: 'Época de Aplicação',
        type: "truncated",
        filter: true,
        numeric: false,
        sortable: true,
        minWidth: 200,
    },
    {
        id: 'manejo',
        label: 'Manejo',
        type: "truncated",
        filter: true,
        numeric: false,
        sortable: true,
        minWidth: 200,
    },
    {
        id: 'grupo_quimico',
        label: 'Grupo Químico',
        type: "text",
        filter: true,
        numeric: false,
        sortable: true,
        minWidth: 150,
    },
    {
        id: 'formulacao',
        label: 'Formulação',
        type: "text",
        filter: true,
        numeric: false,
        sortable: true,
        minWidth: 200,
    },
    {
        id: 'concentracao',
        label: 'Concentração',
        type: "text",
        filter: true,
        numeric: false,
        sortable: true,
        minWidth: 150,
    },
];